import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  missingFlights: {
    display: 'flex',
    gap: 16,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 40,
    borderBottom: `1px solid ${Theme.palette.gray[250]}`,

    [Theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },

    '& svg, >span': {
      color: Theme.palette.error.main,
    },

    '& .left-content': {
      display: 'flex',
      alignItems: 'center',
      color: Theme.palette.error.main,
    },
  },
}));

export default useStyles;
